"use client"

import { useEffect } from "react"

export default function ServiceWorkerRegister() {
  useEffect(() => {
    // Inject the manifest link lazily so it doesn't block the critical path.
    // The browser only needs it for PWA installation, not for rendering.
    const link = document.createElement("link")
    link.rel = "manifest"
    link.href = "/manifest.webmanifest"
    document.head.appendChild(link)

    if (!("serviceWorker" in navigator)) return

    if (process.env.NODE_ENV !== "production") {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister())
      })
      return
    }

    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("Service worker registration failed:", err)
    })
  }, [])

  return null
}
